import { render, staticRenderFns } from "./TelefoneComDDD.vue?vue&type=template&id=2f0489a0&scoped=true&"
import script from "./TelefoneComDDD.vue?vue&type=script&lang=js&"
export * from "./TelefoneComDDD.vue?vue&type=script&lang=js&"
import style0 from "./TelefoneComDDD.vue?vue&type=style&index=0&id=2f0489a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0489a0",
  null
  
)

export default component.exports